import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-empty-cart',
  templateUrl: './empty-cart.component.html',
  styleUrls: ['./empty-cart.component.scss'],
})
export class EmptyCartComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() { }

  empty() {
    localStorage.setItem('sales_chat_id', uuidv4())
    localStorage.removeItem('order')

    this.activeModal.close('empty')
  }

  keep() {
    this.activeModal.close()
  }
}
